export default {
    handle(bloodDonorModel) {
        if (!bloodDonorModel.phone) {
            return true;
        }

        if (!bloodDonorModel.phone.length) {
            return true;
        }

        if (!Array.isArray(bloodDonorModel.phone)) {
            bloodDonorModel.phone = [
                bloodDonorModel.phone,
            ];

            return true;
        }

        bloodDonorModel.phone = bloodDonorModel.phone.map(item => {
            return item.value;
        });

        return true;
    }
}